import { render, staticRenderFns } from "./AddEditLanguage.vue?vue&type=template&id=55406e39"
import script from "./AddEditLanguage.vue?vue&type=script&lang=js"
export * from "./AddEditLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports